const controllingSelectElements = document.querySelectorAll('[data-controls]');

const updateOptions = (parentId, controlledElement, options) => {
    if (!parentId) return;
    options.forEach(option => {
        if (!option.dataset.parent) return;
        const isChildOfCurrentParent = option.dataset.parent == parentId;

        if (!isChildOfCurrentParent) {
            return option.remove();
        }

        option.hidden = false;
        controlledElement.appendChild(option);
    });

    const hasActiveTopicOptions = Boolean(topic.querySelector('option:not([hidden])'));
    controlledElement.disabled = !hasActiveTopicOptions;
};

controllingSelectElements.forEach(controllingElement => {
    const controlledElement = document.getElementById(controllingElement.dataset.controls);
    const options = controlledElement.querySelectorAll('option');
    controllingElement.addEventListener('change', () =>
        updateOptions(controllingElement.value, controlledElement, options),
    );
    updateOptions(controllingElement.value, controlledElement, options);
});

const offerResultsSwitcherButtons = document.querySelectorAll('[data-offer-results-switcher]');
const searchForms = document.querySelectorAll('[data-offer-search-form]');

searchForms.forEach(form =>
    form.addEventListener('change', () => {
        offerResultsSwitcherButtons.forEach(btn => btn.setAttribute('form', form.id));
    }),
);
